const dollarsToCents = (dollarValue) => {
  const centValue = parseFloat(dollarValue) * 100;
  return Math.abs(parseInt(centValue.toFixed(2), 10));
};

export default dollarsToCents;
